__turbopack_context__.v({
  "ReleaseImageCard": "_9YiTZq_ReleaseImageCard",
  "ReleaseImageCard--Highlighted": "_9YiTZq_ReleaseImageCard--Highlighted",
  "ReleaseImageCard--TextLeft": "_9YiTZq_ReleaseImageCard--TextLeft",
  "ReleaseImageCard__Container": "_9YiTZq_ReleaseImageCard__Container",
  "ReleaseImageCard__Content": "_9YiTZq_ReleaseImageCard__Content",
  "ReleaseImageCard__Description": "_9YiTZq_ReleaseImageCard__Description",
  "ReleaseImageCard__Title": "_9YiTZq_ReleaseImageCard__Title",
  "ReleaseImageCard__Video": "_9YiTZq_ReleaseImageCard__Video",
});
